<template>
	<song-form :addition="false" @save="save" @cancel="cancel" @remove="remove" :id="id" :lang="lang"></song-form>
</template>


<script>
	import SongForm from "../components/SongForm.vue"
	import axios from '../ConfiguredAxios.js'

	import {EventBus} from '../event-bus.js'

	export default {
		components: {
			SongForm
		},
		data() {
			return {
				id: parseInt(this.$route.params.id), // FIXME why is parseInt required?,
				lang: this.$route.params.lang
			}
		},
		methods: {
			save: function (data) {
				axios.put("/rest/v1/songs/" + this.id, data.data, {
					headers: {
						"Authorization": "PIN " + data.pin
					}
				}).then((response) => {
					this.goToLyrics(Object.keys(data.data.lyrics))

					EventBus.$emit('SongEdited');
				}, (error) => {
					if (error.response.status === 401) {
						alert("Incorrect PIN.")
					} else {
						alert("Unknown error occurred.")
					}
				})
			},
			cancel: function () {
				this.$router.push({
					name: "lyrics",
					id: this.id,
					lang: this.lang
				})
			},
			goToLyrics: function (langs) {
				let lang;
				if (langs.includes(this.lang)) {
					lang = this.lang
				} else {
					lang = langs[0]
				}
				this.$router.push("/songs/" + this.id + "/lyrics/" + lang)
			},
			remove: function (data) {
				if (confirm("Are you sure?")) {
					axios.delete("/rest/v1/songs/" + this.id, {
						headers: {
							"Authorization": "PIN " + data.pin
						}
					}).then(() => {
						this.close()
						EventBus.$emit('SongRemoved');
					}, (error) => {
						if (error.response.status === 401) {
							alert("Incorrect PIN.")
						} else {
							alert("Unknown error occurred.")
						}
					})
				}
			},
			close: function () {
				this.$router.push({
					name: "list"
				})
			}
		}
	}
</script>
